 import { useEffect } from 'react';
 import { useNavigate } from 'react-router-dom';
 import { App as CapacitorApp } from '@capacitor/app';
 import { isCapacitorNative } from '@/lib/platform';
 
 /**
  * Hook to handle deep links for OAuth callbacks in Capacitor native apps.
  * Listens for appUrlOpen events and navigates to the appropriate route.
  */
 export function useDeepLinkHandler() {
   const navigate = useNavigate();
 
   useEffect(() => {
     // Only register listener on native platforms
     if (!isCapacitorNative()) return;
 
     const handleAppUrlOpen = (event: { url: string }) => {
       console.log('Deep link received:', event.url);
       
       try {
         const url = new URL(event.url);

         // Handle Google OAuth callback deep link from either app:
         //   gyansadhan://auth/google-callback?code=...   (Gyan Sadhan app)
         //   edulyt://auth/google-callback?code=...       (Edulyt app)
         const isKnownScheme = url.protocol === 'gyansadhan:' || url.protocol === 'edulyt:';
         const isGoogleCallback =
           isKnownScheme && (
             url.pathname === '/auth/google-callback' ||
             url.pathname === '//auth/google-callback' ||
             (url.host === 'auth' && url.pathname.includes('google-callback'))
           );
         if (isGoogleCallback) {
           
           const params = new URLSearchParams(url.search);
           const code = params.get('code');
           const state = params.get('state');
           const error = params.get('error');
           
           console.log('OAuth callback params:', { code: !!code, state: !!state, error });
           
           // Navigate to the React route with the same params
           navigate(`/auth/google-callback?${params.toString()}`);
         }
       } catch (err) {
         console.error('Error parsing deep link URL:', err);
       }
     };
 
     // Register the deep link listener
     CapacitorApp.addListener('appUrlOpen', handleAppUrlOpen);
 
     // Check if app was opened via deep link (cold start)
     CapacitorApp.getLaunchUrl().then((launchUrl) => {
       if (launchUrl?.url) {
         console.log('App launched with URL:', launchUrl.url);
         handleAppUrlOpen({ url: launchUrl.url });
       }
     });
 
     return () => {
       CapacitorApp.removeAllListeners();
     };
   }, [navigate]);
 }